import React from 'react';
import { Field, connect } from 'formik';
import { ProductVariationConsumer } from './ProductVariationProvider/ProductVariationContext';
import get from 'lodash.get';
const OptionSwitch = ({ components, options, formik }) => {
    return (React.createElement(ProductVariationConsumer, null, ({ getSelectableOptionItems, selectedOptions, options: contextOptions }) => {
        return (options || contextOptions).map(option => {
            const optionName = option.name;
            const PickerComponent = components[optionName] || components.default;
            // Only render the field component if formik is an empty object
            if (Object.getOwnPropertyNames(formik).length > 0) {
                return (React.createElement(Field, { key: optionName, name: `options[${option.name}]`, render: ({ field: { name }, form: { touched, errors, setTouched } }) => (React.createElement(PickerComponent, { option: option, selectedItem: selectedOptions[optionName] && {
                            value: selectedOptions[optionName],
                            text: selectedOptions[optionName]
                        }, items: getSelectableOptionItems(optionName), error: get(touched, name) && get(errors, name), onChange: () => {
                            let newTouched = Object.assign({}, touched);
                            newTouched[name] = true;
                            setTouched(touched);
                        } })) }));
            }
            else
                return (React.createElement(PickerComponent, { key: optionName, option: option, selectedItem: selectedOptions[optionName] && {
                        value: selectedOptions[optionName],
                        text: selectedOptions[optionName]
                    }, items: getSelectableOptionItems(optionName) }));
        });
    }));
};
export default connect(OptionSwitch);
//# sourceMappingURL=OptionSwitch.js.map